angular.module('qkr').controller('couponProdSelectController', ($scope, $uibModalInstance, gettextCatalog,
                                                       outletService, $filter, inventoryService,
                                                       categoryList, preSelectedCategories,
                                                       preSelectedVariantIds, productList, _) => {
    const vm = $scope;
    vm.init = function() {
        vm.preSelectedVariantIds = angular.copy(preSelectedVariantIds);
        vm.categoryList = angular.copy(categoryList);
        vm.selectedCategoryList = angular.copy(preSelectedCategories);
        vm.showProducts = false;
        vm.productList = productList;
        vm.selectedProductList = [];
        vm.selectedCategoryProductMap = {};

        if (preSelectedVariantIds.length > 0) {
            vm.isEdit = true;
            vm.showProducts = true;
         }

        vm.selectedCategoryProductMap = {};
        inventoryService.setMinMaxPriceVariants(vm.productList);

        const productListSortedByCategoryName = vm.productList.sort((a, b) => {
            const aCatName = a.category.name.toUpperCase();
            const bCatName = b.category.name.toUpperCase();
            if (aCatName < bCatName) {
                return -1;
            }
            if (aCatName > bCatName) {
                return 1;
            }
            // names are equal
            return 0;
        });

        const selectedCats = [];
        angular.forEach(productListSortedByCategoryName, (prod) => {
            angular.forEach(vm.selectedCategoryList, (cat) => {
                selectedCats.push({value: cat.id});
                cat.selected = true;
                if (prod.category.id === cat.id) {
                    let mapValue = vm.selectedCategoryProductMap[prod.category.name];
                    if (!mapValue) {
                        mapValue = [];
                    }
                    angular.forEach(prod.variants, (variant) => { // we have to loop over all variants
                        if (vm.preSelectedVariantIds.indexOf(variant.id) > -1) {
                            prod.selected = true;
                            variant.selected = true;
                            vm.selectedProductList.push(prod);
                            vm.getCategoryForKey(cat.name).showProducts = true;// expand category
                        }
                    });
                    mapValue.push(prod);
                    vm.selectedCategoryProductMap[prod.category.name] = mapValue;
                }
            });
        });
        vm.selectedCategoryList = _.uniq($filter('orderBy')(selectedCats, 'value'), (p) => p.value);
         // Instead or orderby angular filter sort the list here so we can set the first category to be open by default if creating a new coupon
        vm.categoryList.sort((a, b) => {
            if (a.name < b.name)
                return -1;
            else if (a.name > b.name)
                return 1;
            else
                return 0;
        });
    };

    vm.categorySelectInitial = function(category) {
        if (category.selected) {
            vm.selectedCategoryList.push({value: category.id});
        } else {// remove category from selected
            vm.selectedCategoryList = vm.selectedCategoryList.filter((obj) => obj.value !== category.id);
            // need to remove category products
            angular.forEach(vm.selectedCategoryProductMap[category.name], (prod) => {
                prod.selected = false;
                vm.selectedProductList = vm.selectedProductList.filter((obj) => obj.id !== prod.id);
            });
        }
    };

    vm.categorySelectAll = function(key) {
        const category = vm.selectedCategoryProductMap[key];
        if (category) {
            category.selectAll = !category.selectAll;
            angular.forEach(vm.selectedCategoryProductMap[key], (prod) => {
                prod.selected = category.selectAll;
                vm.selectProductVariants(prod);
                if (prod.selected) {
                    vm.selectedProductList.push(prod);
                } else {
                    vm.selectedProductList = vm.selectedProductList.filter((obj) => obj.id !== prod.id);
                }
            });
        }
    };

    vm.selectProductVariants = function(prod) {
        angular.forEach(prod.variants, (variant) => {
            variant.selected = prod.selected;
        });
    };

    vm.getCategoryForKey = function(key) {
        return vm.categoryList.filter((category) => category.name === key)[0];
    };

    vm.toggleCategoryShowProducts = function(key) {
        const cat = vm.getCategoryForKey(key);
        cat.showProducts = !cat.showProducts;
    };

    // Check category is all products are selected
    vm.allProductsSelected = function(cate) {
        const category = $filter('filter')(vm.categoryList, {name: cate});
        let allSelected = true;
        angular.forEach(cate.products, (product) => {
            if (!product.selected) {
                allSelected = false;
            }
        });
        category.selected = allSelected;
    };

    // Check product if all variants are selected
    vm.allVariantsSelected = function(cate, prod) {
        let allSelected = true;
        angular.forEach(prod.variants, (variant) => {
            if (!variant.selected) {
                allSelected = false;
            }
        });
        prod.selected = allSelected;
        vm.allProductsSelected(cate);
    };

    vm.expandVariants = function(prod) {
        if (prod.variants.length > 1) {
            prod.showVariants = !prod.showVariants;
        }
    };

    vm.selectProd = function(prod) {
        prod.selected = !prod.selected;
        if (prod.selected) {
            vm.selectedProductList.push(prod);
        } else {// remove product from list if it's been deselected
            vm.selectedProductList = vm.selectedProductList.filter((obj) => {
                return obj.id !== prod.id;
            });
        }
        vm.selectProductVariants(prod);
    };

    vm.validate = function() {
        vm.errors = {};
        if (vm.selectedProductList.length < 1) {
            vm.errors.noneSelected = gettextCatalog.getString('At least one product must be selected');
            return false;
        }
        return true;
    };

    vm.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    vm.back = function() {
        // set categories to selected true if we have products selected within them (this is only used for UI)
        angular.forEach(vm.selectedCategoryList, (selectedCategory) => {
            if (selectedCategory.value && !selectedCategory.id) {
                selectedCategory.id = selectedCategory.value;
            }
            const categoryInList = $filter('filter')(vm.categoryList, {'id': selectedCategory.id});
            if (categoryInList && categoryInList.length > 0) {
                categoryInList[0].selected = true;
            }
        });
        vm.showProducts = false;
    };

    vm.OK = function() {
        if (!vm.validate()) {
            return;
        }
        const result = {};
        result.productList = vm.selectedProductList;
        result.categoryLits = vm.selectedCategoryList;
        $uibModalInstance.close(result);
    };

    vm.showNext = function() {
        vm.errors = {};
        if (vm.selectedCategoryList.length < 1) {
            vm.errors.noneSelected = gettextCatalog.getString('At least one category must be selected');
            return false;
        }
        let outletId;
        if (outletService.outletInfo) {
            outletId = outletService.outletInfo.id;
        }
        inventoryService.getProductsForSelectedCategories(vm.selectedCategoryList, outletId).then((response) => {
            if (response.data.length < 1) {
                vm.showProducts = false;
            } else {
                vm.showProducts = true;
                vm.selectedCategoryProductMap = {};
                vm.productList = response.data;
                inventoryService.setMinMaxPriceVariants(vm.productList);
                angular.forEach(vm.productList, (prod) => {
                    const prodFoundInSelectedList = $filter('filter')(vm.selectedProductList, {'id': prod.id});
                    if (prodFoundInSelectedList && prodFoundInSelectedList.length > 0) {
                        prod.selected = true;
                    }

                    let mapValue = vm.selectedCategoryProductMap[prod.category.name];
                    if (!mapValue) {
                        mapValue = [];
                    }
                    mapValue.push(prod);
                    vm.selectedCategoryProductMap[prod.category.name] = mapValue;
                });
            }
        });
    };
});




// WEBPACK FOOTER //
// ./src/coupons/controllers/coupon.product.controller.js